import { useState, useEffect } from 'react';
import useToken from 'hooks/useToken';

let cachedStatusOptions = null;
let cachedAccounts = null;
let fetchPromise = null;

const useMarketingCatalogos = () => {
    const [statusOptions, setStatusOptions] = useState(
        cachedStatusOptions || [{ value: 'todos', label: 'Todos' }]
    );
    const [accounts, setAccounts] = useState(
        cachedAccounts || []
    );
    const { token, setToken } = useToken();

    useEffect(() => {
        if (!token) return;
        if (cachedStatusOptions && cachedAccounts) {
            setStatusOptions(cachedStatusOptions);
            setAccounts(cachedAccounts);
            return;
        }

        if (fetchPromise) {
            fetchPromise.then(result => {
                setStatusOptions(result.statusOptions);
                setAccounts(result.accounts);
            });
            return;
        }

        fetchPromise = (async () => {
            try {
                const response = await fetch('/api/marketing/ObtenerCatalogosMarketing', {
                    method: 'GET',
                    headers: {
                        'Authorization': 'Bearer ' + token,
                        'Content-Type': 'application/json'
                    }
                });

                if (response.ok) {
                    const result = await response.json();
                    if (result.iResponseType === 1 && result.detalles) {
                        const dataset = JSON.parse(result.detalles);
                        
                        let statusOpts = [{ value: 'todos', label: 'Todos' }];
                        let accountsList = [];

                        // table2 contiene los estados de publicaci�n
                        if (dataset.table2 && dataset.table2.length > 0) {
                            const estados = dataset.table2.map(estado => ({
                                value: estado.idCatEstadoPublicacion,
                                label: estado.vNombreEstado
                            }));
                            
                            statusOpts = [
                                { value: 'todos', label: 'Todos' },
                                ...estados
                            ];
                        }

                        // table3 contiene las cuentas comerciales
                        if (dataset.table3 && dataset.table3.length > 0) {
                            const colors = ['#2c7be5', '#00d97e', '#e63757', '#f5803e', '#27bcfd'];
                            accountsList = dataset.table3.map((cuenta, index) => ({
                                id: cuenta.idCatCuentaComercial,
                                name: cuenta.vDescripcion,
                                color: colors[index % colors.length]
                            }));
                        }
                        
                        cachedStatusOptions = statusOpts;
                        cachedAccounts = accountsList;
                        
                        return { statusOptions: statusOpts, accounts: accountsList };
                    }
                } else if (response.status === 401) {
                    setToken(null);
                    location.href = '';
                }
            } catch (error) {
                console.error('Error fetching catalogos marketing:', error);
            }
            
            return { 
                statusOptions: [{ value: 'todos', label: 'Todos' }], 
                accounts: [] 
            };
        })();

        fetchPromise.then(result => {
            setStatusOptions(result.statusOptions);
            setAccounts(result.accounts);
        });
    }, [token, setToken]);

    return { statusOptions, accounts };
};

export default useMarketingCatalogos;
